<template>
  <div>
    <img class="bg" src="../assets/0.開始遊戲/0_2.拍照上傳/腳色介面_03-完成.png" />
    <img class="face" v-if="Player.pictureUrl" :src="`${host}/${Player.pictureUrl}`" />
    <img class="plane" v-show="Player.carType == 1" src="../assets/0.開始遊戲/0_2.拍照上傳/腳色介面_03-完成1.png" />
    <img class="plane" v-show="Player.carType == 2" src="../assets/0.開始遊戲/0_2.拍照上傳/腳色介面_03-完成2.png" />
    <img class="plane" v-show="Player.carType == 3" src="../assets/0.開始遊戲/0_2.拍照上傳/腳色介面_03-完成3.png" />
    <img
      class="car"
      v-show="Player.carType == 1"
      src="../assets/0.開始遊戲/0_2.拍照上傳/HeySong_Car_step03_1.png"
    />
    <img
      class="car"
      v-show="Player.carType == 2"
      src="../assets/0.開始遊戲/0_2.拍照上傳/HeySong_Car_step03_2.png"
    />
    <img
      class="car"
      v-show="Player.carType == 3"
      src="../assets/0.開始遊戲/0_2.拍照上傳/HeySong_Car_step03_3.png"
    />
    <img v-if="isShowCountdown" class="mask" src="../assets/0.開始遊戲/0_2.拍照上傳/倒數開始_壓黑.png" />
    <img
      v-if="isShowCountdown"
      class="countdown"
      :src="
        require(`../assets/0.開始遊戲/0_2.拍照上傳/倒數開始_${countdown}.png`)
      "
    />
  </div>
</template>
<script>
export default {
  props: {
    Player: {
      id: "",
      carType: 1
    },
    OnCountdownEnded: {
      type: Function
    }
  },
  data() {
    return {
      host: "",
      countdown: 3,
      isShowCountdown: true
    };
  },
  mounted() {
    this.host = process.env.VUE_APP_BASEURL;
  },
  methods: {
    async Countdown() {
      this.isShowCountdown = false;
      await this.Delay(1500);
      this.isShowCountdown = true;
      for (var i = 0; i < 4; i++) {
        this.countdown = 3 - i;
        await this.Delay(1000);
      }
      if (this.OnCountdownEnded) {
        this.OnCountdownEnded();
      }
    },
    Delay(interval) {
      return new Promise(resolve => {
        setTimeout(resolve, interval);
      });
    }
  }
};
</script>
<style scoped>
.bg {
  position: absolute;
  top: 0;
  left: 0;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100vw;
  max-width: 100vw;
}
.car {
  position: absolute;
  left: 0vw;
  top: 35vw;
  width: 100vw;
  z-index: 3;
}
.countdown {
  position: absolute;
  left: 30vw;
  top: 65vw;
  width: 40vw;
  z-index: 4;
}
.face {
  position: absolute;
  left: 41vw;
  top: 61vw;
  width: 18vw;
  z-index: 2;
}
.plane {
  position: absolute;
  left: -10vw;
  top: 42vw;
  width: 120vw;
  z-index: 1;
}
.mask {
  position: absolute;
  left: 0vw;
  top: 0vw;
  width: 100vw;
  height: 100vh;
  z-index: 3;
}
</style>
